import Api from '../Api'

import { showMessage } from 'store/actions'

export const generateProductDescription = (
    sku,
    productName,
    producerUrl,
    specificationUrl
) => dispatch => {
    Api.generateProductDescription(
        sku,
        productName,
        producerUrl,
        specificationUrl
    )
        .then(response => {
            dispatch(
                showMessage({
                    message:
                        'Dodano do kolejki generowania opisu produktu. Generowanie opisu na żądanie trwa około minuty.',
                    autoHideDuration: 4000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                    variant: 'success',
                })
            )
        })
        .catch(error => {
            dispatch(
                showMessage({
                    message: error,
                    autoHideDuration: 4000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                    variant: 'error',
                })
            )
        })
}
